<div class="section">
    <div data-qa-id="locums-work-practice-setting-label" class="nova__label">Practice Setting</div>
    <div data-qa-id="locums-work-unit-practice-setting-value">{{ practiceSettingsText | nullDash }}</div>

    <div data-qa-id="locums-work-avg-daily-census-label" class="nova__label">Avg. Daily Census</div>
    <div data-qa-id="locums-work-avg-daily-census-value"> {{ (unitDetails$ | async)?.averageDailyCensus | nullDash }}</div>

    <div data-qa-id="locums-work-beds-label" class="nova__label">Beds</div>
    <div data-qa-id="locums-work-beds-value">{{ (unitDetails$ | async)?.beds | nullDash }}</div>

    <div data-qa-id="locums-work-charting-software-label" class="nova__label">Charting Software</div>
    <div data-qa-id="locums-work-charting-software-value"> {{ facilityProfileDetails?.chartingSoftware | nullDash }}</div>

    <div data-qa-id="locums-work-patient-age-group-label" class="nova__label">Patient Age Group</div>
    <div data-qa-id="locums-work-patient-age-group-value">{{ patientAgeGroupsText | nullDash }}</div>

    <div data-qa-id="locums-work-procedures-label" class="nova__label">Procedures</div>
    <div class ="preserve-newlines" data-qa-id="locums-work-procedures-value">
        <div [innerHTML]="(unitDetails$ | async)?.unitDetails"></div>
    </div>

    <div data-qa-id="locums-work-equipment-label" class="nova__label">Equipment</div>
    <div class ="preserve-newlines" data-qa-id="locums-work-equipment-value">
        <div [innerHTML]="(unitDetails$ | async)?.specialEquipment"></div>
    </div>

    <div data-qa-id="locums-work-vaccines-label" class="nova__label">Vaccines</div>
    <div data-qa-id="locums-work-vaccines-value">
        <label *ngIf="vaccinationRequirements?.length === 0" data-qa-id="locums-work-vaccination-requirements-dash">-</label>
        <div class="jd__section__container" *ngIf="vaccinationRequirements?.length > 0">
            <ng-container *ngFor=" let vaccinationRequirement of vaccinationRequirements; let i=index">
                <label [attr.data-qa-id]="'locums-work-vaccination-requirements-label-' + i">
                    {{ getVaccinationType(vaccinationRequirement.vaccinationTypeId) }}
                </label>
                <label class="jd__section__emphasized" [attr.data-qa-id]="'locums-work-vaccination-requirements-details-' + i">
                    {{ vaccinationRequirement.vaccinationStatus }}
                </label>
            </ng-container>
        </div>
    </div>

</div>
